import { type PollContentObjectDetail, createPollContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getPoll } from '../../services';
import { getContentObjectDetailQueryKey } from '../keys';

export const usePollQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<PollContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<PollContentObjectDetail>({
    async queryFn() {
      const { data } = await getPoll({ routeParams: { id } });
      return createPollContentObjectDetail(data);
    },
    queryKey: getContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
